INTERSTITIAL_SET